import { formatDefault, isNonValue } from '@/utils/api';
import i18n, { EN, ZH_HK } from '@/locales';
import dayjs from 'dayjs';

/**
 * @param {number} amount - 需要转换的数字
 * @return {string} - 转换后的字符串
 */
export const convertNumberToUnit = amount => {
	const positive = amount > 0 ? 1 : -1;
	amount = Math.abs(amount);

	// 定义单位和对应的值
	const units = [
		{ name: '万亿', value: 1e12 },
		{ name: '亿', value: 1e8 },
		{ name: '万', value: 1e4 }
	];

	const enUnits = [
		{ name: 'B', value: 1e9 },
		{ name: 'M', value: 1e6 },
		{ name: 'K', value: 1e3 }
	];

	const hkUnits = [
		{ name: '萬億', value: 1e12 },
		{ name: '億', value: 1e8 },
		{ name: '萬', value: 1e4 }
	];

	const selectedUnits = i18n.locale === EN ? enUnits : i18n.locale === ZH_HK ? hkUnits : units;

	// 遍历单位，找到合适的单位进行转换
	for (let unit of selectedUnits) {
		if (amount >= unit.value) {
			return [((positive * amount) / unit.value).toFixed(2), unit.name];
		}
	}

	// 如果没有合适的单位，直接返回原值
	return [(positive * amount).toFixed(2), ''];
};
export const formatterColTransferUnit = (value, split = false) => {
	const nonValue = isNonValue(value);
	if (nonValue) return formatDefault(value);

	const [v, u] = convertNumberToUnit(value);

	if (split) return [v, u];
	return `${v}${u}`;
};

/** 四舍五入保留至小数点后两位 */
export const roundToTwoDecimals = num => {
	if (isNonValue(num)) return '-';
	return `${parseFloat(num.toFixed(2))}%`;
};

export const formatPercentage = (value, unit = '%') => {
	if (isNonValue(value)) return '-';
	return `${value}${unit}`;
};

/** 企业号标准化年月日格式（YYYY.MM.DD） */
export const normalizeYMDFormat = (date, t = '.') => {
	return dayjs(date).format(`YYYY${t}MM${t}DD`);
};

/** 时间显示年月日**/
export const dateFormatYearMonthDate = (date, t = '-') => {
	return dayjs(date).format(`YYYY${t}MM${t}DD`);
};

/** 时间显示月日时间**/
export const dateFormatYearMonthDateTime = (date, t = '-') => {
	dayjs(date).format(`YYYY${t}MM${t}DD HH:mm`);
};

/** 时间显示年月**/
export const dateFormatYearMonth = (date, t = '-') => {
	return dayjs(date).format(`YYYY${t}MM`);
};
